import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomFieldsIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 436,
	viewBox: "0 0 436 436",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8532_2731)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M218 404C320.725 404 404 320.725 404 218C404 115.275 320.725 32 218 32C115.275 32 32 115.275 32 218C32 320.725 115.275 404 218 404Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.484 85.0072C286.631 85.0072 291.633 90.0091 291.633 96.1557V335.037C291.633 341.184 286.631 346.186 280.484 346.186H158.892C152.745 346.186 147.743 341.184 147.743 335.037V96.1557C147.743 90.0091 152.745 85.0072 158.892 85.0072H280.484ZM280.484 75.2321H158.892C147.343 75.2321 137.968 84.5951 137.968 96.1557V335.037C137.968 346.586 147.331 355.961 158.892 355.961H280.484C292.034 355.961 301.408 346.598 301.408 335.037V96.1557C301.408 84.6065 292.045 75.2321 280.484 75.2321Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M247.829 77.899H191.537C188.591 77.899 186.203 80.2871 186.203 83.233V87.8572C186.203 90.803 188.591 93.1911 191.537 93.1911H247.829C250.775 93.1911 253.163 90.803 253.163 87.8572V83.233C253.163 80.2871 250.775 77.899 247.829 77.899Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M329.371 142.032L344.091 150.502C345.59 151.36 347.456 150.296 347.467 148.568L347.593 132.051C347.605 130.334 345.773 129.235 344.262 130.048L329.417 138.094C327.86 138.93 327.837 141.15 329.371 142.032Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.376 285.109L96.9342 272.198C94.4847 270.847 91.4973 272.644 91.5202 275.437L91.8063 301.454C91.8406 304.235 94.8395 305.952 97.2547 304.59L120.41 291.484C122.894 290.077 122.871 286.494 120.376 285.109Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_8532_2731",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 147,
				y: 85,
				width: 145,
				height: 262,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M291.633 96.1557V335.037C291.633 336.697 291.267 338.276 290.615 339.695C288.852 343.53 284.972 346.185 280.485 346.185H158.892C152.746 346.185 147.744 341.184 147.744 335.037V96.1557C147.744 92.9851 149.083 90.1121 151.212 88.0747C153.215 86.1746 155.916 85.0071 158.892 85.0071H280.485C286.631 85.0071 291.633 90.0091 291.633 96.1557Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_8532_2731)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M291.634 96.1557V335.037C291.634 336.697 291.267 338.276 290.615 339.696C288.852 343.53 284.972 346.185 280.485 346.185H158.893C152.746 346.185 147.744 341.184 147.744 335.037V96.1557C147.744 92.9851 149.083 90.1121 151.212 88.0747C153.215 86.1746 155.917 85.0071 158.893 85.0071H280.485C286.632 85.0071 291.634 90.0091 291.634 96.1557Z",
						fill: "#EBF3FF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M159.877 246.283V226.173H157.336V308.814H159.877V248.813H200.03V246.283H159.877Z",
						fill: "#DCEBFE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.633 273.766H243.125V316.563H291.633V273.766Z",
						fill: "#C2F4F1"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M147.732 216.352H199.687V189.121H147.732V216.352Z",
						fill: "#FFE3E0"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.633 295.422H243.125V297.963H291.633V295.422Z",
						fill: "#9AEDE6"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M243.136 85.0071H236.784V333.32H243.136V85.0071Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.634 119.781V117.239H176.463V85.0071H173.132V117.239H147.744V119.781H173.132V139.033H147.744V141.574H173.132V186.58H147.744V189.121H173.132H176.463H291.634V186.58H176.463V141.574H291.634V139.033H176.463V119.781H291.634Z",
						fill: "#DCEBFE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.634 158.961H147.744V165.153H291.634V158.961Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M203.865 308.871H147.744V315.224H203.865V308.871Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M172.777 308.871H200.042V284.365L191.652 278.241C191.652 278.241 174.117 287.135 172.777 308.883V308.871Z",
						fill: "#C2F4F1"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.634 316.574H204.666V322.927H291.634V316.574Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.634 226.436V216.283H210.206V85.0071H200.053V216.283H147.744V226.436H200.053V252.808C193.483 254.925 188.698 261.038 188.573 268.283C184.589 270.32 180.572 273.09 176.909 276.753C168.61 285.052 162.166 297.883 162.166 316.998V333.32H172.319V316.998C172.319 294.174 182.643 283.346 191.663 278.241C193.712 281.091 196.642 283.266 200.053 284.365V333.32H210.206V284.365C215.231 282.751 219.214 278.791 220.862 273.777H291.634V263.624H220.942C219.34 258.508 215.311 254.456 210.206 252.819V226.447H291.634V226.436Z",
						fill: "#9EC5FF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M291.622 113.428H205.879V123.581H291.622V113.428Z",
						fill: "#9EC5FF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M210.645 269.877C211.365 266.825 209.475 263.768 206.424 263.047C203.372 262.327 200.314 264.217 199.594 267.269C198.874 270.32 200.764 273.378 203.816 274.098C206.867 274.819 209.925 272.929 210.645 269.877Z",
						fill: "#EBF3FF"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M247.829 77.899H191.537C188.591 77.899 186.203 80.2871 186.203 83.233V87.8572C186.203 90.803 188.591 93.1911 191.537 93.1911H247.829C250.775 93.1911 253.163 90.803 253.163 87.8572V83.233C253.163 80.2871 250.775 77.899 247.829 77.899Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.208 321.839H287.169C289.63 321.839 291.633 323.843 291.633 326.303V335.037C291.633 341.195 286.643 346.185 280.485 346.185H158.892C152.734 346.185 147.744 341.195 147.744 335.037V326.303C147.744 323.843 149.747 321.839 152.208 321.839Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M219.682 335.575C220.75 335.575 221.616 334.709 221.616 333.641C221.616 332.572 220.75 331.706 219.682 331.706C218.614 331.706 217.748 332.572 217.748 333.641C217.748 334.709 218.614 335.575 219.682 335.575Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M228.302 335.575C229.37 335.575 230.236 334.709 230.236 333.641C230.236 332.572 229.37 331.706 228.302 331.706C227.233 331.706 226.367 332.572 226.367 333.641C226.367 334.709 227.233 335.575 228.302 335.575Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M211.076 335.575C212.144 335.575 213.01 334.709 213.01 333.641C213.01 332.572 212.144 331.706 211.076 331.706C210.007 331.706 209.141 332.572 209.141 333.641C209.141 334.709 210.007 335.575 211.076 335.575Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M357.872 164.684H290.9C284.016 164.684 278.436 170.265 278.436 177.149V276.261C278.436 283.145 284.016 288.726 290.9 288.726H357.872C364.756 288.726 370.337 283.145 370.337 276.261V177.149C370.337 170.265 364.756 164.684 357.872 164.684Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M308.711 272.61H299.84C297.391 272.61 295.399 270.618 295.399 268.169V260.74C295.399 258.29 297.391 256.299 299.84 256.299H308.711C311.16 256.299 313.152 258.29 313.152 260.74V268.169C313.152 270.618 311.16 272.61 308.711 272.61ZM299.84 260.351C299.634 260.351 299.462 260.522 299.462 260.729V268.157C299.462 268.363 299.634 268.535 299.84 268.535H308.711C308.917 268.535 309.089 268.363 309.089 268.157V260.729C309.089 260.522 308.917 260.351 308.711 260.351H299.84Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.359 266.486H320.272C319.15 266.486 318.246 265.582 318.246 264.46C318.246 263.338 319.15 262.434 320.272 262.434H351.359C352.481 262.434 353.385 263.338 353.385 264.46C353.385 265.582 352.481 266.486 351.359 266.486Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.359 245.139H320.272C319.15 245.139 318.246 244.235 318.246 243.113C318.246 241.991 319.15 241.087 320.272 241.087H351.359C352.481 241.087 353.385 241.991 353.385 243.113C353.385 244.235 352.481 245.139 351.359 245.139Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M303.308 247.749C302.793 247.749 302.266 247.554 301.877 247.153L298.501 243.777C297.711 242.987 297.711 241.705 298.501 240.904C299.29 240.114 300.572 240.114 301.374 240.904L303.319 242.85L310.736 235.433C311.526 234.631 312.808 234.643 313.609 235.433C314.399 236.222 314.399 237.504 313.609 238.306L304.762 247.153C304.361 247.554 303.846 247.749 303.331 247.749H303.308Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M311.974 207.069C311.31 207.069 310.795 207.641 310.852 208.294C311.47 215.23 317.296 220.667 324.393 220.667C331.489 220.667 337.316 215.23 337.934 208.294C337.991 207.641 337.464 207.069 336.812 207.069H311.985H311.974Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M333.893 216.787C331.443 214.383 328.09 212.907 324.392 212.907C320.695 212.907 317.342 214.395 314.892 216.787C317.342 219.19 320.695 220.667 324.392 220.667C328.09 220.667 331.443 219.179 333.893 216.787Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M313.713 191.662C313.713 189.522 311.973 187.782 309.833 187.782C307.692 187.782 305.953 189.522 305.953 191.662C305.953 193.803 307.692 195.543 309.833 195.543C311.973 195.543 313.713 193.803 313.713 191.662Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M342.843 191.536C342.843 189.396 341.103 187.656 338.963 187.656C336.822 187.656 335.083 189.396 335.083 191.536C335.083 193.677 336.822 195.417 338.963 195.417C341.103 195.417 342.843 193.677 342.843 191.536Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.968 229.034H239.153C235.456 229.034 232.457 226.035 232.457 222.338V191.033C232.457 189.797 231.45 188.801 230.225 188.801H179.61C175.913 188.801 172.914 185.802 172.914 182.105V146.027C172.914 144.79 171.918 143.795 170.682 143.795H108.701C107.465 143.795 106.469 142.799 106.469 141.563C106.469 140.326 107.465 139.331 108.701 139.331H170.682C174.379 139.331 177.378 142.329 177.378 146.027V182.105C177.378 183.341 178.385 184.337 179.61 184.337H230.225C233.922 184.337 236.921 187.336 236.921 191.033V222.338C236.921 223.574 237.917 224.57 239.153 224.57H274.968C276.204 224.57 277.2 225.566 277.2 226.802C277.2 228.038 276.204 229.034 274.968 229.034Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.447 234.242C282.556 234.242 285.887 230.911 285.887 226.802C285.887 222.693 282.556 219.362 278.447 219.362C274.338 219.362 271.007 222.693 271.007 226.802C271.007 230.911 274.338 234.242 278.447 234.242Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M123.238 87.7885C123.318 91.6115 122.688 95.2743 121.452 98.6623C120.296 101.833 118.613 104.763 116.507 107.339L95.3777 137.499C94.4162 138.861 92.4017 138.861 91.4402 137.499L70.3106 107.339C66.0984 102.199 63.5688 95.6177 63.5688 88.4638C63.5688 71.6151 77.5446 58.017 94.5307 58.6466C110.086 59.2189 122.894 72.2332 123.226 87.7999L123.238 87.7885ZM112.295 88.4638C112.295 78.0364 103.836 69.5777 93.409 69.5777C82.9815 69.5777 74.5228 78.0364 74.5228 88.4638C74.5228 98.8913 82.9815 107.339 93.409 107.339C103.836 107.339 112.295 98.8798 112.295 88.4638Z",
				fill: "#9EC5FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8532_2731",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 372,
			height: 372,
			fill: "white",
			transform: "translate(32 32)"
		})
	}) })]
});
export default SvgCustomFieldsIllustration;
